import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeSubstancesList } from "../../../Art57Node/ListEntity/TreeNodeSubstancesList";

export class ApprovedSubstancesQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).approvedSubstancesFields;
    const createChidTemplateParams = {nodeTypeToCreateName: 'addApprovedSubstance'};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).approvedSubstancesConditions;
       super(injector, [], 'Approved Substances', EntityEnum.approvedSubstance,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.approvedSubstanceTreeNode, TreeNodeSubstancesList, AutoUploadEntityEnum.approvedSubstance, createChidTemplateParams);    
    }
}